<template>
  <div class="tab-inner" :class="props.type">
    <ul
      class="tab-link-box"
      ref="tabBox"
      :class="[tabItems.length > 2 ? 'many-tabs' : 'few-tabs', props.type]"
    >
      <li
        v-for="(tab, idx) in tabItems"
        :key="tab.key"
        @click="setTabSelect(tab, idx)"
        class="tab-link"
        :class="[{ active: tab.isActive }, props.type ? tab.key : '']"
        :ref="(el) => (tabRefs[idx] = el)"
      >
        {{ tab.value }}
      </li>
    </ul>
    <div
      class="tab-underline"
      :style="{
        width: underlineWidth + 'px',
        left: underlineLeft + 'px',
        top: underlineBottom + 'px',
      }"
    />
  </div>
</template>

<script setup>
import {
  watch,
  ref,
  computed,
  onMounted,
  nextTick,
  defineProps,
  defineEmits,
} from "vue";

const props = defineProps({
  tabItems: Array,
  type: String,
});

const tabItems = computed(() => props.tabItems);
const underlineLeft = ref(0);
const underlineBottom = ref(0);
const underlineWidth = ref(0);
const tabRefs = [];
const emit = defineEmits(["tabSelectHandler"]);

function setTabSelect(tab, idx) {
  emit("tabSelectHandler", tab.key);
  if (tab?.isBeta) return;
  if (props.type !== "circle") {
    updateUnderline(idx);
  }
}

const updateUnderline = (index) => {
  nextTick(() => {
    const tabEl = tabRefs[index];
    if (tabEl) {
      underlineLeft.value = tabEl.offsetLeft;
      underlineBottom.value = tabEl.offsetTop + tabEl.offsetHeight - 1;
      underlineWidth.value = tabEl.offsetWidth;
    }
  });
};

onMounted(() => {
  const activeIndex = tabItems.value.findIndex((tab) => tab.isActive);
  setTimeout(() => {
    nextTick(() => {
      if (props.type !== "circle") {
        updateUnderline(activeIndex >= 0 ? activeIndex : 0);
      }
    });
  }, 0);
});

watch(
  () => props.tabItems,
  (newVal) => {
    if (!newVal || newVal.length === 0) return;
    const activeIndex = newVal.findIndex((tab) => tab.isActive);
    setTimeout(() => {
      nextTick(() => {
        if (props.type !== "circle") {
          updateUnderline(activeIndex >= 0 ? activeIndex : 0);
        }
      });
    }, 0);
  },
  { immediate: true, deep: true }
);
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/common/tab.scss";
</style>
